import {
  FORM_CONSTANTS,
  LOCAL_STORAGE,
  PHONE_TRANSLATIONS
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Vue, Prop } from "vue-property-decorator";
import {
  FIELD_GROUP_CONSTANTS,
  INFO_GROUP_CONSTANTS
} from "../../constants/InfoGroupConstants";
import { FieldGroup } from "../../models/FieldGroup";
import {
  DEFAULT_VALUE,
  VISUALIZATION
} from "./constants/SchemaVisualizationConstants";
import VuePhoneNumberInput from "vue-phone-number-input";
import Vuetify from "vuetify";
import draggable from "vuedraggable";
import { ESCHEMA_TYPES } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import ModifVJsfInput from "@/shared/components/ModifVJsfInput/ModifVJsfInput.vue";
import { PhoneSchema } from "@/shared/models/PhoneSchema";
import WarningDeleteMessage from "@/shared/components/WarningDeleteMessage/WarningDeleteMessage.vue";
import { SAVE_INFO_GROUP_CONSTANTS } from "../SaveInfoGroup/constants/SaveInfoGroupConstants";

Vue.use(Vuetify);

@Component({
  name: "SchemaVisualization",
  components: {
    draggable,
    ModifVJsfInput,
    VuePhoneNumberInput,
    WarningDeleteMessage
  }
})
export default class SchemaVisualization extends Vue {
  @Prop({ default: "" }) formName!: string;
  @Prop({ default: {} }) fieldsGroup!: FieldGroup[];

  roundBtnClassTertiary = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  cardClass = STYLE_CLASSES.CARD;

  FIELDS_TITLE = FORM_CONSTANTS.PREVIEW_TEXT;
  PREFERRED_COUNTRIES = INFO_GROUP_CONSTANTS.PREFERRED_COUNTRIES;
  TRANSLATIONS = PHONE_TRANSLATIONS;
  INACTIVE_ELEMENTS = SAVE_INFO_GROUP_CONSTANTS.INACTIVE_ELEMENTS;

  defaultCountry = "";
  model = {};

  mounted() {
    this.defaultCountry = localStorage.getItem(LOCAL_STORAGE.COUNTRY) || "";
  }

  saveNewFieldOrder() {
    this.$emit(VISUALIZATION.EVENT.NEW_FIELD_ORDER);
  }

  updateField(index: number, id: string) {
    this.$emit(VISUALIZATION.EVENT.UPDATE_FIELD, index, id);
  }

  deleteField(index: number) {
    this.$emit(VISUALIZATION.EVENT.DELETE_FIELD, index);
  }

  getSchema(index: number) {
    const schema = JSON.parse(JSON.stringify(DEFAULT_VALUE.SCHEMA));
    schema.properties.field = this.fieldsGroup[index].schema;

    if (
      schema.properties.field.type === ESCHEMA_TYPES.ARRAY ||
      schema.properties.field.type === ESCHEMA_TYPES.LIST ||
      this.fieldsGroup[index].type === ESCHEMA_TYPES.LIST
    ) {
      if (!this.fieldsGroup[index].state) {
        schema.properties.field["x-class"] =
          STYLE_CLASSES.OUTTER_BORDER_ELEMENT_VOIDED;
      } else {
        schema.properties.field["x-class"] = "";
      }
    }

    return schema;
  }

  createPhoneTypeListTemp(field: FieldGroup) {
    if (field.type === FIELD_GROUP_CONSTANTS.FIELD_TYPE.PHONE) {
      const phoneSchema: PhoneSchema = {
        slot: "field",
        title: field.schema.title.trim(),
        countryCode: "",
        countryCallingCode: "",
        required: field.required,
        enabled: field.editable,
        model: "",
        formattedNumber: ""
      };

      return [phoneSchema];
    }
    return [];
  }
}
